import { useAuth } from '@/hooks/useAuth';

const UserInfo = () => {
  const { user, logout } = useAuth();

  return (
    <div className="p-4">
      <div className="flex items-center mb-3">
        <div className="w-10 h-10 rounded-full bg-admin-accent flex items-center justify-center text-white font-bold">
          {user?.name?.charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U'}
        </div>
        <div className="ml-3 flex-1 min-w-0">
          <p className="text-sm font-medium truncate">
            {user?.name || user?.email || 'ユーザー'}
          </p>
          <p className="text-xs text-gray-400 truncate">{user?.email}</p>
        </div>
      </div>
      <button
        onClick={logout}
        className="w-full px-4 py-2 text-sm bg-admin-sidebarHover hover:bg-gray-700 rounded transition-colors"
      >
        ログアウト
      </button>
    </div>
  );
};

export default UserInfo;
